import { z } from 'zod';
import { validatePartnerName } from '@bridebook/toolbox/src/validation/partner-names/validate';
import { getPartnerNameErrorMessages } from './translations';

export type PartnerNameValidationMessages = {
  required?: string;
  tooLong?: string;
  containsNumbers?: string;
  containsInvalidCharacters?: string;
  invalid?: string;
};

export type CreatePartnerNameSchemaOptions = {
  allowEmpty?: boolean;
  // Per-rule messages. Any missing keys fall back to defaults
  messages?: PartnerNameValidationMessages;
};

const resolveMessages = ({ messages }: Pick<CreatePartnerNameSchemaOptions, 'messages'>) => {
  const errorMessages = getPartnerNameErrorMessages();
  return {
    required: messages?.required ?? errorMessages.required,
    tooLong: messages?.tooLong ?? errorMessages.tooLong,
    containsNumbers: messages?.containsNumbers ?? errorMessages.containsNumbers,
    containsInvalidCharacters:
      messages?.containsInvalidCharacters ?? errorMessages.containsInvalidCharacters,
    invalid: messages?.invalid ?? errorMessages.invalid,
  };
};

export const createPartnerNameSchema = (options: CreatePartnerNameSchemaOptions = {}) => {
  const { allowEmpty = false } = options;
  const messages = resolveMessages(options);

  return z.string().superRefine((value, ctx) => {
    const error = validatePartnerName(value, { allowEmpty });

    if (error) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: messages[error] });
    }
  });
};
